export const FormsConstants = {
  reformsForm: [
    {
      label: "Identificador",
      key: "reId",
      type: "text",
      value: "",
      required: true,
      readonly: true,
    },
    {
      label: "Descripción",
      key: "reDescr",
      type: "text-area",
      value: "",
      required: true,
      readonly: true,
    },
    {
      label: "Es tramitable",
      key: "reTramitable",
      type: "checkbox",
      value: false,
      required: true,
      readonly: false,
    },
  ],
  reformsChildForm: [
    {
      label: "Identificador",
      key: "reId",
      type: "text",
      value: "",
      required: true,
      readonly: true,
    },
    {
      label: "Descripción",
      key: "reDescr",
      type: "text-area",
      value: "",
      required: true,
      readonly: true,
      maxlength: 1024,
    },
    {
      label: "Es tramitable",
      key: "reTramitable",
      type: "checkbox",
      value: false,
      required: true,
      readonly: false,
    },
  ],
  otherCertificateForm: [
    {
      label: "Identificador",
      key: "tcId",
      type: "text",
      value: "",
      required: true,
      readonly: true,
      maxlength: 3,
    },
    {
      label: "Descripción",
      key: "tcDescr",
      type: "text-area",
      value: "",
      required: true,
      readonly: false,
      maxlength: 64,
    },
    {
      label: "Es tramitable",
      key: "tcTramitable",
      type: "checkbox",
      value: false,
      required: true,
      readonly: false,
    },
  ],
  changeStateToRE: [
    {
      label: "Motivo de rechazo",
      key: ["id", "descr"],
      type: "list",
      list: null,
      value: "",
      required: true,
      readonly: false,
    },
    {
      label: "Introduzca comentario de rechazo",
      key: "tcDescr",
      type: "text-area",
      value: "",
      required: true,
      readonly: false,
    },
  ],
  changeStateToCA: [
    {
      label: "Analista al que asignarlo",
      key: ["usuarioId", "nombre"],
      type: "list",
      list: null,
      value: "",
      required: true,
      readonly: false,
    },
    {
      label: "Corrección para el analista",
      key: "comentario",
      type: "text-area",
      value: "",
      required: true,
      readonly: false,
    },
  ],
  changeStateToPC: [
    {
      label: "Corrección para el usuario",
      key: "comentario",
      type: "text-area",
      value: "",
      required: true,
      readonly: false,
    },
  ],

  changeStateToPA: [
    {
      label: "Corrección a realizar",
      key: "comentario",
      type: "text-area",
      value: "",
      required: true,
      readonly: false,
    },
  ],
  
  permisosTablaRolesForm: [
    {
      label: "Analista avanzado",
      key: "AAVANZA",
      type: "checkbox",
      value: false,
      required: false,
      readonly: false
    },
    {
      label: "Analista",
      key: "ANALISTA",
      type: "checkbox",
      value: false,
      required: false,
      readonly: false
    },
    {
      label: "Analista basico",
      key: "ABASICO",
      type: "checkbox",
      value: false,
      required: false,
      readonly: false
    }
  ],
};
